import styled from "styled-components"

export const ProductImage = styled.div`
    width:30px;
    height:30px;

     @media (min-width: 760px) {
        width:40px;
        height:40px;
    }
    margin-right:15px;

    span{
    margin-top:10px;
    }

`

export const ProductDescription = styled.div`
    display:none;
    @media (min-width: 760px) {
        display:block;
    }
`
export const ProductTitle = styled.div`
font-size:0.9rem;
font-weight:600;
`

export const ProductOverride = styled.div`
    color: ${props => props.theme.application.scheme.warning};
    font-weight:600;


button{
    line-height: 1rem;
}
}

`
export const ProductContainer = styled.div`
    display:flex;
    align-items: center;


    div.approvalicon{
        display:none;
         @media (min-width: 760px) {
            display:block;
        }
    }
`
export const ProductNameContainer = styled.div`
    display:flex;
    flex-direction:column;   
    gap:3px;
`